import retrievePropertyDetails from "../queries/property/getPropertyDetails";

export default async (clientObj, jwt, success, fail) => {
  await retrievePropertyDetails(clientObj, jwt)
    .then((response) => {
      success(response);
    })
    .catch((err) => {
      fail(err);
    });
};
